import { availableProtocols } from './index';
import { registerCustomAttributes } from './customAttributes';

const initHangingProtocols = () => {
  registerCustomAttributes();
  return availableProtocols;
};

export default initHangingProtocols;
